<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="far fa-comments"></i>
          Ayudas
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="success" @click="showCreateHelp"
          v-if="organization && organization.superUser">
          Crear
        </b-button>
      </template>
      <template v-slot:body>
        <div v-if="helps && organization">
          <HelpsComponent :helps="helps" :superUser="organization.superUser"></HelpsComponent>
        </div>
        <div v-else>No hay ayudas</div>
      </template>
    </iq-card>
    <b-modal id="modal-create-help" centered @ok="createHelp" size="xl">
      <template #modal-title>Crear ayuda global</template>
      <template #modal-ok>Crear</template>
      <template #modal-cancel>Cerrar</template>
      <b-form-group label-for="title">
        <template slot="label">Título: *</template>
        <b-form-input v-model="newHelpGlobal.title" type="text" required />
      </b-form-group>
      <b-form-group label-for="content">
        <template slot="label">Contenido: *</template>
        <ckeditor id="newHelpGlobal.content" v-model="newHelpGlobal.content" :config="configCK" type="classic"></ckeditor>
      </b-form-group>
      <b-form-group label-for="urlRef">
        <template slot="label">URL de referencia:</template>
        <b-form-input v-model="newHelpGlobal.urlRef" type="text" />
      </b-form-group>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import HelpsComponent from '../../components/helps/HelpsComponent';

import utilsService from "../../services/utils";
import helpService from "../../services/help";
import organizationService from "../../services/organization";

export default {
  name: "Helps",
  mounted() {
    xray.index();
    this.getHelps();
    this.getOrganization();

    this.$root.$on("getHelps", () => {
      this.getHelps();
    });

    //utilsService.auditActivity({ action: "VIEW", module: "HELP", info: "" });
  },
  watch: {
  },
  computed: {
  },
  methods: {
    async getOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(localStorage.getItem("organizationId")),
        (response) => {
          if (response) {
            this.organization = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId
            }),
          });
        },
        " "
      );
    },
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    showCreateHelp() {
      this.$bvModal.show("modal-create-help");
    },
    createHelp() {
      let self = this;

      this.$awn.asyncBlock(
        helpService.create(this.newHelpGlobal),
        (response) => {
          if (response) {
            //utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_CONTACTS", info: "" });
            self.getHelps();
            self.$bvModal.hide("modal-create-help");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.create",
            module: "view-pages-professional-contact-contacts",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    async getHelps() {

      let self = this;

      this.$awn.asyncBlock(
        helpService.getAll(
        ),
        (response) => {
          if (response) {
            self.helps = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "helpService.getAll",
            module: "view-pages-professional-contact-contacts",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        },
        " "
      );

    },
  },
  data() {
    return {
      organization: undefined,
      helps: undefined,
      role: localStorage.getItem("role"),
      newHelpGlobal: {
        title: "",
        content: "",
        urlRef: "",
      },
      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
        mediaEmbed: {
          previewsInData: true
        }
      },
    };
  },

  components: {
    DatePicker,
    Multiselect,
    HelpsComponent
  },
};
</script>
